<form [formGroup]="liabilitiesForm" id="liabilities-form" (ngSubmit)=onSubmit(liabilitiesForm)>
	<div class="d-flex flex-column justify-content-lg-start  justify-content-sm-center  text-right flex-column m-step-wrapper1 container" [ngClass]="{'first-question' : !prevQID}">
		<questions-manager [(editQid)]="qID" [visibleQids]="visibleQids" [(editQuestion)]="editQuestion" (editQuestionChange)="editQuestionChange($event)">
			<question [qID]="'1'" >
				<div class="mx-4 mt-md-0 mt-5">
				<h1 class="app-title-xxxlarge-blue">{{"LIABILITIES.QUESTION1.QUESTION"|translate}}</h1>
				<div class="row mt-4">
			    <div class="col-12 col-md-4 col-lg-4 "> 
				<div class="input-wrapper">
					<app-animated-input formControlName="realtyLien" [type]="'text'" placeholder="{{'LIABILITIES.QUESTION1.PH1'|translate}}" attAriaLabel="{{'BLIABILITIES.QUESTION1.REQUIRED1'|translate}}" [hasCurrencyMask]="true" [animatedLabel]="true"></app-animated-input>
					<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="liabilitiesForm.get('realtyLien').hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
				</div>
			</div>
			</div>
				<div class="d-flex justify-content-md-end justify-content-center mt-5">
					<button type="submit" class="app-button" [ngClass]="{'button-primary': liabilitiesForm.valid && qID=='1', 'button-primary-disabled': !liabilitiesForm.valid}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
				</div>
			</question>
			<question [qID]="'2'">
				<div class="mx-4 mt-md-0 mt-5">
				<h1 class="app-title-xxxlarge-blue">{{"LIABILITIES.QUESTION2.QUESTION"|translate}}</h1>
				<div class="row mt-4">
					<div class="col-12 col-md-4 col-lg-4 justify-content-center"> 
					<div class="input-wrapper">
						<app-animated-input formControlName="monthlyRefundAmount" [type]="'text'" placeholder="{{'LIABILITIES.QUESTION2.PH1'|translate}}" attAriaLabel="{{'LIABILITIES.QUESTION2.QUESTION'|translate}}" [hasCurrencyMask]="true" [animatedLabel]="true"></app-animated-input>
						<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="liabilitiesForm.get('monthlyRefundAmount').hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
					</div>
				</div>
				</div>

				<div class="d-flex justify-content-md-end justify-content-center mt-5">
					<button type="submit" class="app-button" [ngClass]="{'button-primary': liabilitiesForm.valid && qID=='2', 'button-primary-disabled': !liabilitiesForm.valid}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
				</div>
			</question>
			<question [qID]="'3'">
				<div class="mx-4 mt-md-0 mt-5">
				<h1 class="app-title-xxxlarge-blue">{{"LIABILITIES.QUESTION3.QUESTION"|translate}}</h1>
				<div class="row">
					<div class="col-12 col-md-4 col-lg-4 justify-content-center"> 
					<div class="">
						<app-animated-input formControlName="whenLiabilitiesEnd" [minValue]="0" [type]="'number'" placeholder="{{'LIABILITIES.QUESTION3.PH2'|translate}}" attAriaLabel="{{'LIABILITIES.QUESTION3.QUESTION'|translate}}" [hasCurrencyMask]="false" [animatedLabel]="false" [hasTitle]="true"></app-animated-input>
						<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="liabilitiesForm.get('whenLiabilitiesEnd').hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
						<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="liabilitiesForm.get('whenLiabilitiesEnd').hasError('negativeNumber') && !liabilitiesForm.get('whenLiabilitiesEnd').hasError('required') && submitted" role="alert">{{ 'COMMON.NEGATIVE_NUMBER' | translate }}</label>
					</div>
				</div>
				</div>
				<div class="d-flex justify-content-md-end justify-content-center mt-5">
					<button type="submit" class="app-button" [ngClass]="{'button-primary': liabilitiesForm.valid && qID=='3', 'button-primary-disabled': !liabilitiesForm.valid}">{{"COMMON.PROCEED"|translate}}</button>
				</div>     
				</div>
			</question>
			<question [qID]="'3.1'">
				<div class="mx-4 mt-md-0 mt-5">
				<h1 class="app-title-xxxlarge-blue">{{"LIABILITIES.QUESTION3-1.QUESTION"|translate}}</h1>
				<div class="row">
					<div class="col-12 col-md-4 col-lg-4 justify-content-center"> 
					<div class="input-wrapper">
						<app-animated-input formControlName="amountOfAlimonyPayment" [type]="'text'" placeholder="{{'LIABILITIES.QUESTION3-1.PH1'|translate}}" attAriaLabel="{{'LIABILITIES.QUESTION3-1.QUESTION'|translate}}" [hasCurrencyMask]="true" [animatedLabel]="true" [hasTitle]="false"></app-animated-input>
						<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="liabilitiesForm.get('amountOfAlimonyPayment').hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
					</div>
				</div>
				</div>
				<div class="d-flex justify-content-md-end justify-content-center mt-5">
					<button type="submit" class="app-button" [ngClass]="{'button-primary': liabilitiesForm.valid && qID=='3.1', 'button-primary-disabled': !liabilitiesForm.valid}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
				</div>
			</question>
			<question [qID]="'3.2'">
				<div class="mx-4 mt-md-0 mt-5">
				<h1 class="app-title-xxxlarge-blue">{{"LIABILITIES.Q3-2.QUESTION"|translate}}</h1>

				<div class="row justify-content-md-start justify-content-center mb-4">
					<div class="col-md-3 col-lg-3 col-md-5 m-datepicker">
						<app-date-picker formControlName="endDate" firstDayOfWeek=7 placeholder="dd/mm/yyyy" attAriaLabel="{{'LIABILITIES.Q3-2.QUESTION'|translate}}" #endAlimonyPaymentDate></app-date-picker>
						<label class="app-error d-flex justify-content-md-end justify-content-center mr-md-2 mr-0" *ngIf="liabilitiesForm.get('endDate').hasError('required') && submitted" role="alert">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
						<label class="app-error d-flex justify-content-md-end justify-content-center mr-md-2 mr-0" *ngIf="liabilitiesForm.get('endDate').hasError('invalidDate') && !liabilitiesForm.get('endDate').hasError('required') && submitted" role="alert">{{ 'COMMON.DATE_ERROR' | translate }}</label>
					</div>
				</div>
                <div class="d-flex justify-content-md-end justify-content-center mt-5">
                    <button type="submit" class="app-button" [ngClass]="{'button-primary': liabilitiesForm.valid && qID=='3.2', 'button-primary-disabled': !liabilitiesForm.valid}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
				</div>
            </question>
			<question [qID]="'4'">
				<div class="mx-4 mt-md-0 mt-5">
				<h1 class="app-title-xxxlarge-blue text-md-right text-center">{{"LIABILITIES.QUESTION4.QUESTION"|translate}}</h1>
				<div class="d-flex justify-content-center justify-content-md-start text-center w-100">
					<inner-tooltip [qTitle]="'LIABILITIES.QUESTION4.TOOLTIP_TITLE'|translate" [text]="'LIABILITIES.QUESTION4.TOOLTIP_TEXT'|translate"
					class="m-start-tooltip app-title-small-blue"></inner-tooltip>
				</div>

				<div class="btn-group-toggle text-center text-md-right" data-toggle="buttons">
					<label class="app-label text-center button-secondary-disabled" [ngClass]="{'selected':liabilitiesForm.get('haveYouLiabilities').value==='YES'}" tabindex="0" data-id="qID4a" data-fieldName="haveYouLiabilities" data-fieldValue="YES">
						{{"COMMON.YES"|translate}}
						<input class="radio" type="radio" formControlName="haveYouLiabilities" value="YES" (change)="onSubmit(liabilitiesForm)" click2change tabindex="-1">
					</label>
					<label class="app-label text-center button-secondary-disabled" [ngClass]="{'selected':liabilitiesForm.get('haveYouLiabilities').value==='NO'}" tabindex="0" data-id="qID4b" data-fieldName="haveYouLiabilities" data-fieldValue="NO">
						{{"COMMON.NO"|translate}}
						<input class="radio" type="radio" formControlName="haveYouLiabilities" value="NO" (change)="onSubmit(liabilitiesForm)" click2change tabindex="-1">
					</label>
				</div>
				</div>
			</question>
			<question [qID]="'5'">
				<div class="mx-4 mt-md-0 mt-5">
				<h1 class="app-title-xxxlarge-blue text-md-right text-center">{{"LIABILITIES.QUESTION5.QUESTION"|translate}}</h1>
				<app-liabilities-array formArrayName="liabilitiesArray"
					[liabilitiesArray]="liabilitiesForm.get('liabilitiesArray')"
					[displayErrors]="submitted"
					[types]="liabilitiesTypes"
					(onAddFormGroup)="setValidators()">
				</app-liabilities-array>
				<br/>
				<div class="d-flex justify-content-md-end justify-content-center mt-5">
					<button type="submit" class="app-button" [ngClass]="{'button-primary': liabilitiesForm.valid && qID=='5', 'button-primary-disabled': !liabilitiesForm.valid}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
				</div>
			</question>
		</questions-manager>
	</div>
</form>


// WEBPACK FOOTER //
// ./src/app/liabilities/liabilities.component.html